export default __webpack_public_path__ + "static/proj3-078cd92a782797c2ff75473781c7fb0c.jpg";